import React from "react";
import "./LogoSlider.css";
import mitsubishu from "../images/mitsubishi.jpg";
import toshiba from "../images/toshiba.jpg";
import carrier from "../images/carrier.jpg";
import Hitachi from "../images/Hitachi logo.jpg";


function LogoSlider() {
  return (
    <div className="slider">
      <div className="slidenew-track">
        <div className="slidenew">
          <img src={mitsubishu} alt="mitsubishu" />
        </div>
        <div className="slidenew">
          <img src={toshiba} alt="toshiba" />
        </div>
        <div className="slidenew">
          <img src={carrier} alt="carrier" />
        </div>
          <div className="slidenew">
          <img src={Hitachi} alt="Hitachi"/>
        </div>

        {/* Duplicate logos for smooth infinite effect */}
        <div className="slidenew">
            <img src={mitsubishu} alt="mitsubishu" />
        </div>
        <div className="slidenew">
            <img src={toshiba} alt="toshiba" />
        </div>
        <div className="slidenew">
                 <img src={carrier} alt="carrier" />
        </div>
          <div className="slidenew">
          <img src={Hitachi} alt="Hitachi"/>
        </div>
      </div>
    </div>
  );
}

export default LogoSlider;
